import { Injectable } from '@angular/core';
import { IApiConfig } from '@brafton/assets-api';
import { AtlasClientConfig } from '@brafton/atlas-api-client';
import { CoreApiClientConfig } from '@brafton/core-api-client';
import { DeliverableClientConfig } from '@brafton/deliverables-client';
import { LogentriesClientConfig } from '@brafton/logentries-client';
import { TextApiClientConfig } from '@brafton/text-api-client';
import { Auth0, BfAuthConfig, DelegateClient } from '@brafton/skynet-angular-security-service';
import { of } from 'rxjs';

import { environment } from '../../../environments/environment';

/* eslint-disable @typescript-eslint/ban-types */
@Injectable()
export class AppAtlasConfig {
  private static config = {};
  private static env: string;

  constructor() {
    AppAtlasConfig.config = environment;
  }

  public load() {
    return of(AppAtlasConfig.config);
  }
}

class EnvData {
  env!: string;
}

// export class AppAtlasConfigRegister {
//   private static config: IEnvironment = environment;
//   private static env: string;

//   constructor(private http: HttpClient) { }

//   public static get Auth0Domain(): string {
//     return environment['auth0:Domain'] as string;
//   }

//   // Atlas Region
//   public static get AtlasAuth0ApiClientId(): string {
//     return environment['atlas:Auth0:ClientId'] as string;
//   }

//   public static get AtlasAuth0ApiAppName(): string {
//     return environment['atlas:Auth0:AppName'] as string;
//   }

//   public static get AtlasGuiEndpoint(): string {
//     return environment['atlas:Endpoint'] as string;
//   }

//   public static get AtlasLoggingLogentriesToken(): string {
//     return environment['atlas:Logging:LogentriesToken'] as string;
//   }

//   // Deliverables Region
//   public static get DeliverablesAuth0ApiClientId(): string {
//     return environment['deliverables:Api:Auth0:ClientId'] as string;
//   }

//   public static get DeliverablesAuth0ApiAppName(): string {
//     return environment['deliverables:Api:Auth0:AppName'] as string;
//   }

//   public static get DeliverablesApiEndpoint(): string {
//     return environment['deliverables:Api:Endpoint'] as string;
//   }

//   // Core Api Region
//   public static get CoreAuth0ApiClientId(): string {
//     return environment['core:Api:Auth0:ClientId'] as string;
//   }

//   public static get CoreAuth0ApiAppName(): string {
//     return environment['core:Api:Auth0:AppName'] as string;
//   }

//   public static get CoreApiEndpoint(): string {
//     return environment['core:Api:Endpoint'] as string;
//   }

//   // Assets Api Region
//   public static get AssetsAuth0ApiClientId(): string {
//     return environment['assets:Api:Auth0:ClientId'] as string;
//   }

//   public static get AssetsAuth0ApiAppName(): string {
//     return environment['assets:Api:Auth0:AppName'] as string;
//   }

//   public static get AssetsApiEndpoint(): string {
//     return environment['assets:Api:Endpoint'] as string;
//   }

//   // Pictures
//   public static get PicturesEndpoint(): string {
//     return environment['pictures:Endpoint'] as string;
//   }

//   // Scribe Region
//   public static get ScribeEndpoint(): string {
//     return environment['scribe:Endpoint'] as string;
//   }

//   /**
//    * Use to get the data found in the first file (env file)
//    */
//   public static getEnv(key: string) {
//     return this.env;
//   }

//   /**
//    * This method:
//    *   a) Loads "env.json" to get the current working environment (e.g.: 'production', 'development')
//    *   b) Loads "config.[env].json" to get all env's variables (e.g.: 'config.development.json')
//    */
//   public load() {
//     return new Promise((resolve, reject) => {
//       this.http
//         .get<any>('/assets/environments/env.json')
//         .pipe(
//           catchError((error: any): any => {
//             console.log('Configuration file "env.json" could not be read');
//             resolve(true);
//             return throwError(error.error || 'Server error');
//           }),
//         )
//         .subscribe((envResponse: EnvData) => {
//           AppAtlasConfigRegister.env = envResponse.env;
//           let request: any = null;
//           request = this.http.get<any>('./assets/environments/env.' + AppAtlasConfigRegister.env + '.json');
//           if (request) {
//             request
//               .pipe(
//                 catchError((error: any): any => {
//                   console.error('Error reading ' + AppAtlasConfigRegister.env + ' configuration file');
//                   resolve(error);
//                   return throwError(error.error || 'Server error');
//                 }),
//               )
//               .subscribe((responseData: any) => {
//                 AppAtlasConfigRegister.config = responseData;
//                 resolve(true);
//               });
//           } else {
//             console.error('Env config file "env.json" is not valid');
//             resolve(true);
//           }
//         });
//     });
//   }
// }

@Injectable()
export class ATLAS_AUTH_CONFIG implements BfAuthConfig {
  Auth0: Auth0 = {
    Domain: environment['auth0:Domain'],
    ClientId: environment['atlas:Auth0:ClientId'],
    AppName: environment['atlas:Auth0:AppName'],
  };
  DelegateClients: DelegateClient[] = [
    {
      Auth0: {
        // Deliverables delegate settings
        ClientId: environment['deliverables:Api:Auth0:ClientId'],
        AppName: environment['deliverables:Api:Auth0:AppName'],
        Required: true,
      },
    },
    {
      Auth0: {
        // Core-Api delegate settings
        ClientId: environment['core:Api:Auth0:ClientId'],
        AppName: environment['core:Api:Auth0:AppName'],
        Required: true,
      },
    },
    {
      Auth0: {
        // Assets-Api delegate settings
        ClientId: environment['assets:Api:Auth0:ClientId'],
        AppName: environment['assets:Api:Auth0:AppName'],
        Required: true,
      },
    },
    {
      Auth0: {
        // Text-Api delegate settings
        ClientId: environment['text:Api:Auth0:ClientId'],
        AppName: environment['text:Api:Auth0:AppName'],
        Required: true,
      },
    },
    {
      Auth0: {
        // Atlas-Api delegate settings
        ClientId: environment['atlas:Api:Auth0:ClientId'] as string,
        AppName: environment['atlas:Api:Auth0:AppName'] as string,
        Required: true,
      },
    },
  ];
  AutoLogin = true;
  LoginPageURL = '/login';
  HomePageURL = '/my';
  LogoutURL = '/';
}

@Injectable()
export class ATLAS_AUTH_CONFIG_OPTIONS implements Auth0LockConstructorOptions {
  autoclose = true;
  closable = false;
  languageDictionary: any = { title: 'Login to Brafton' };
  configurationBaseUrl!: 'https://cdn.us.auth0.com';
  auth: Auth0LockAuthOptions = {
    audience: 'https://brafton.com/management/api',
    params: {
      scope:
        'openid given_name family_name email picture profile https://brafton.com/app_metadata atlas-api.brafton.com/things:read assets-api.brafton.com/assets:read assets-api.brafton.com/assets:create assets-api.brafton.com/assets:modify deliverables-api.brafton.com/deliverables:read core-api.brafton.com/objects:read tagging-api.brafton.com/tags:read text-api.brafton.com/text:read',
    },
    redirectUrl: environment['atlas:Endpoint'],
    responseType: 'token id_token',
    sso: true,
  };

  rememberLastLogin = true;

  allowedConnections = ['Staff-External-Users', 'brafton-com', 'castleford-com-au'];

  defaultDatabaseConnection = 'Staff-External-Users';

  theme: Auth0LockThemeOptions = {
    logo: '/assets/brafton-b.svg',
    primaryColor: '#8bc34a',
  };

  constructor() {
    if (window.location.pathname && window.location.pathname.length > 1) {
      const queryString = window.location.href.split('?')[1];
      const url: string =
        queryString != null && queryString.length >= 2
          ? `${window.location.pathname}?${queryString}`
          : window.location.pathname;

      const encodedState = encodeURIComponent(`ru=${url}`);
      Object.assign(this.auth.params as {}, { state: encodedState });
    }
  }
} //Use any of auth0 options

// DeliverableBase Client Angular Config
@Injectable()
export class DELIVERABLES_CLIENT_APP_CONFIG implements DeliverableClientConfig {
  Auth0ApiAppName: string = environment['deliverables:Api:Auth0:AppName'];
  DeliverablesApiURL: string = environment['deliverables:Api:Endpoint'];
}

// Core-Api Client Angular Config
@Injectable()
export class CORE_API_CLIENT_APP_CONFIG implements CoreApiClientConfig {
  Auth0ApiAppName: string = environment['core:Api:Auth0:AppName'];
  CoreApiURL: string = environment['core:Api:Endpoint'];
}

// // Assets-Api Client Angular Config
@Injectable()
export class ASSETS_API_CLIENT_APP_CONFIG implements IApiConfig {
  Auth0ApiAppName: string = environment['assets:Api:Auth0:AppName'];
  AssetsApiEndpoint: string = environment['assets:Api:Endpoint'];
}

// // Assets-Api Client Angular Config
@Injectable()
export class TEXTAPI_CLIENT_APP_CONFIG implements TextApiClientConfig {
  auth0ApiAppName: string = environment['text:Api:Auth0:AppName'];
  TextApiEndpoint: string = environment['text:Api:Endpoint'];
}

// // Logentries-Api Client Angular Config
@Injectable()
export class LOGENTRIES_CLIENT_APP_CONFIG implements LogentriesClientConfig {
  LogentriesToken: string = environment['atlas:Logging:LogentriesToken'];
}

// // Atlas-Api Client Angular Config
@Injectable()
export class ATLAS_CLIENT_APP_CONFIG implements AtlasClientConfig {
  auth0ApiAppName: string = environment['atlas:Api:Auth0:AppName'] as string;
  atlasApiEndpoint: string = environment['atlas:Api:Endpoint'] as string;
  atlasWebSocketEndpint: string = environment['atlas:Wss:Endpoint'] as string;
}
